import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  suppressHydrationWarning?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, suppressHydrationWarning, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        suppressHydrationWarning={suppressHydrationWarning}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

// Specialized SearchInput component that automatically suppresses hydration warnings
export interface SearchInputProps extends Omit<InputProps, 'suppressHydrationWarning'> {
  suppressHydrationWarning?: boolean
}

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ suppressHydrationWarning = true, ...props }, ref) => {
    return <Input {...props} ref={ref} suppressHydrationWarning={suppressHydrationWarning} />
  }
)
SearchInput.displayName = "SearchInput"

export { Input, SearchInput }
